(function () {
  'use strict';
  if (window.FrostskinGenderSize) {
    window.FrostskinGenderSize.init(document);
    return;
  }
  var LABELS = {
    "Women's": { S: 'S', M: 'M', L: 'L', XL: 'XL', XXL: '2XL', '2XL': '2XL' },
    "Men's": { S: 'XS', M: 'S', L: 'M', XL: 'L', XXL: 'XL', '2XL': 'XL' }
  };
  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }
  function relabel(picker) {
    var product = picker.closest('product-info');
    if (!product) return;
    var checked = picker.querySelector('input[name="properties[Fit]"]:checked');
    var fit = checked ? checked.value : "Women's";
    var locale = window.FrostskinLocale || {};
    var displayFit = fit === "Men's" ? (locale.men || fit) : (locale.women || fit);
    var labels = LABELS[fit] || LABELS["Women's"];
    var selections = [];
    var selectedRows = [];
    product.querySelectorAll('[data-fs-size-option]').forEach(function (group) {
      // Shopify keeps the previous selector hidden for 500 ms during a swap.
      // Only the current selector may contribute sizes to the order.
      var selector = group.closest('variant-selects');
      if (selector && (selector.hidden || selector.style.display === 'none')) return;
      var baseName = group.dataset.fsSizeName || 'Size';
      var displayName = baseName === 'Size' ? (locale.size || baseName) : baseName;
      setText(group.querySelector('[data-fs-size-legend]'), displayFit + ' ' + displayName);
      group.querySelectorAll('[data-fs-size-label]').forEach(function (node) {
        var physical = node.dataset.fsPhysicalSize;
        setText(node, labels[physical] || physical);
      });
      group.querySelectorAll('option[data-fs-physical-size]').forEach(function (option) {
        var physical = option.dataset.fsPhysicalSize;
        var unavailable = /unavailable/i.test(option.textContent);
        setText(option, (labels[physical] || physical) + (unavailable ? ' - Unavailable' : ''));
      });
      var selected = group.querySelector('input[data-fs-physical-size]:checked, option[data-fs-physical-size]:checked');
      if (selected) {
        var physical = selected.dataset.fsPhysicalSize;
        var display = labels[physical] || physical;
        var prefix = baseName === 'Size' ? '' : baseName.replace(/\s*size\s*/i, '') + ': ';
        selections.push(prefix + displayFit + ' ' + display);
        selectedRows.push(physical === '2XL' ? 'XXL' : physical);
        setText(group.querySelector('[data-selected-value]'), display);
      }
    });
    var selectedSize = picker.querySelector('[data-fs-selected-size]');
    if (selectedSize) {
      selectedSize.value = selections.join(' / ');
      selectedSize.disabled = selections.length === 0;
    }
    setText(picker.querySelector('[data-fs-size-summary]'), selections.length ? (locale.summary || 'YOUR SIZE:') + ' ' + selections.join(' / ') : '');
    product.querySelectorAll('[data-fs-chart-size]').forEach(function (row) {
      setText(row.querySelector('[data-fs-chart-label]'), labels[row.dataset.fsChartSize]);
      var active = selectedRows.indexOf(row.dataset.fsChartSize) !== -1;
      row.classList.toggle('is-selected', active);
      if (active) row.setAttribute('aria-current', 'true');
      else row.removeAttribute('aria-current');
    });
    setText(product.querySelector('[data-fs-chart-caption]'), fit === "Men's" ? (locale.menChart || fit + ' size guide') : (locale.womenChart || fit + ' size guide'));
    product.querySelectorAll('[data-fs-chart-image]').forEach(function (link) {
      var source = fit === "Men's" ? link.dataset.fsMenChart : link.dataset.fsWomenChart;
      var img = link.querySelector('img');
      if (link.getAttribute('href') !== source) link.setAttribute('href', source);
      if (img.getAttribute('src') !== source) img.setAttribute('src', source);
      img.alt = 'FROSTSKIN ' + fit.toLowerCase() + ' size chart';
    });
  }
  function init(picker) {
    if (!picker || picker.dataset.fsGenderSizeReady === 'true') return;
    var product = picker.closest('product-info');
    if (!product) return;
    picker.dataset.fsGenderSizeReady = 'true';
    var queued = false;
    var observer;
    var observe = function () {
      if (observer) observer.observe(product, { childList: true, subtree: true });
    };
    var update = function () {
      // Our own label writes must not queue another animation frame.
      if (observer) observer.disconnect();
      if (!picker.isConnected) return;
      relabel(picker);
      observe();
    };
    var refresh = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    };
    product.addEventListener('change', function (event) {
      if (event.target.matches('input[name="properties[Fit]"], [data-fs-physical-size], select')) refresh();
    });
    product.addEventListener('submit', update, true);
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function (mutations) {
        if (!picker.isConnected) { observer.disconnect(); return; }
        if (mutations.some(function (mutation) {
          return mutation.target.closest('variant-selects') || Array.from(mutation.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches('variant-selects') || node.querySelector('variant-selects'));
          });
        })) refresh();
      });
    }
    update();
  }
  function initAll(root) {
    (root || document).querySelectorAll('[data-fs-gender-size]').forEach(init);
  }
  window.FrostskinGenderSize = { init: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('product-info:loaded', function (event) { initAll(event.target); });
}());
